<template>
  <a-select :allow-clear="allowClear" v-model:value="selectedKey" show-search :filter-option="filterOption" :mode="mode"
    :options="optionsComputed" style="min-width: 150px;" placeholder="请选择">
  </a-select>
</template>

<script setup lang='ts'>
import { getSimpleGood } from '@src/scripts/api/good'
import { computed, onMounted, ref } from 'vue'

const props = withDefaults(defineProps<{
  value: string[] | string | number[] | number | undefined,
  mode?: 'multiple' | 'single',
  allowClear?: boolean,
  options?: SimpleGood[]
}>(), {
  allowClear: true
})
const emit = defineEmits(['update:value', 'onSelect'])

const selectedKey = computed({
  get() {
    return props.value
  },
  set(val) {
    emit('update:value', val)
    if (props.mode === 'multiple') {
      if (!val) {
        emit('onSelect', [])
        return
      }
      const ids = val as any[]
      const goods = ids.map(id => options.value.first(a => id === a.id))
      emit('onSelect', goods)
    } else {
      if (!val) {
        emit('onSelect', null)
        return
      }
      emit('onSelect', options.value.first(a => val === a.id))
    }
  }
})
const options = ref<SimpleGood[]>([])
const optionsComputed = computed(() => {
  return options.value.map(good => ({ label: `${good.name}(${good.code})`, value: good.id, option: good }))
})
const filterOption = (input: string, { option }) => {
  if (!input) return true
  const lower = input.toLowerCase()
  if (option.name.toLowerCase().indexOf(lower) > -1) return true      // 名称中包含
  if (option.code.indexOf(lower) > -1) return true                   // 编码中包含
  if (option.name.toPinyin().indexOf(lower) > -1) return true         // 拼音中包含
  if (option.name.toPinyin(true).indexOf(lower) > -1) return true     // 拼音首字母中包含
  return false
}

onMounted(async () => {
  if (!props.options || props.options.length === 0) {
    const result = await getSimpleGood()
    options.value = result.data
  } else options.value = props.options
})

</script>
